<template>
  <div class="applicant-form">
    <validation-observer ref="validator" v-slot="{ invalid, handleSubmit }" tag="div">
      <t-form @submit.native.prevent="handleSubmit(submit)">
        <t-validation-wrapper vid="meta.position" :name="$t('fields.position')" rules="required">
          <t-input v-model="form.meta.position" />
        </t-validation-wrapper>

        <t-validation-wrapper
          vid="meta.phonenumber"
          :name="$t('fields.phonenumber')"
          rules="required"
        >
          <t-phonenumber v-model="form.meta.phonenumber" />
        </t-validation-wrapper>

        <slot name="footer" :invalid="invalid" :loading="loading" />
      </t-form>
    </validation-observer>
  </div>
</template>
<script>
import Vue from 'vue';
import FormBaseMixin from '../../FormBaseMixin';
import Employee from '~/models/Employee';

export default Vue.extend({
  mixins: [FormBaseMixin],

  props: {
    employee: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    form: null,
  }),

  created() {
    this.form = this.getForm(this.employee);
  },

  methods: {
    async request(payload) {
      const model = await new Employee({ id: this.employee.id, ...payload }).patch();
      this.$emit('updated', model);

      return model;
    },

    getForm(model = null) {
      return {
        meta: {
          position: model?.meta?.position,
          phonenumber: model?.meta?.phonenumber ?? '',
        },
      };
    },

    getPayload() {
      return { ...this.form };
    },
  },
});
</script>
